export const CLASS_NAME = 'cst-emissions-details-modal'
